module.exports = __webpack_public_path__ + "media/images/social/twitter-e6c614efd7b3867027d3c069e29f8bb0.png";